module.exports = __webpack_public_path__ + "img/1655.12846206.gif";